import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider } from './context/AuthContext';
import { BranchProvider } from './context/BranchContext';

ReactDOM.createRoot(document.getElementById('root')).render(
  <AuthProvider>
    <BranchProvider>
      <App />
    </BranchProvider>
  </AuthProvider>
);